let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1tJE7")).then(() => parcelRequire('6F7ay'));